import React from 'react';
import type { IIconProps } from '@/types/common-types';

const TipIcon: React.FC<IIconProps> = (props) => {
  const { className = '', onClick } = props;
  return (
    <div className={`${className}`} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path d="M24 2C36.1305 2 46 11.8695 46 24C46 36.1305 36.1305 46 24 46C11.8695 46 2 36.1305 2 24C2 11.8695 11.8695 2 24 2ZM23.8047 29.877C22.8077 29.8772 22.0002 30.6869 22 31.6816C22 32.6766 22.8098 33.4871 23.8047 33.4873C24.802 33.4873 25.6104 32.6767 25.6104 31.6816C25.6101 30.6868 24.8019 29.877 23.8047 29.877ZM23.8047 14C22.8707 14.0002 22.1133 14.7584 22.1133 15.6924V24.9131C22.1134 25.847 22.8708 26.6052 23.8047 26.6055C24.7388 26.6055 25.4969 25.8471 25.4971 24.9131V15.6924C25.4971 14.7582 24.7388 14 23.8047 14Z" fill="#0094FF" />
      </svg>
    </div>
  );
};

export default TipIcon;

